import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { DiscountUsageReport } from 'types';
import { client } from 'utils/api-client';

interface UseDiscountUsageReportParams {
  startDate?: string;
  endDate?: string;
}

function useDiscountUsageReport(
  discountId: string | undefined,
  params: UseDiscountUsageReportParams = {},
): UseQueryResult<AxiosResponse<DiscountUsageReport>> {
  const apiParams: Record<string, string> = {};
  if (params.startDate) apiParams.start_date = params.startDate;
  if (params.endDate) apiParams.end_date = params.endDate;

  return useQuery(
    ['discounts', discountId, 'usage_report', params.startDate, params.endDate],
    () => client.get(`discounts/${discountId}/usage_report/`, { params: apiParams }),
    { enabled: !!discountId },
  );
}

export default useDiscountUsageReport;
